(function (root, factory) {
  var engine = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = engine;
  }
  root.EmergencyFundEngine = engine;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  function getMonthsToReach(target, currentSavings, monthlyContribution) {
    var remaining = target - currentSavings;
    if (remaining <= 0) return 0;
    if (monthlyContribution <= 0) return Infinity;
    return Math.ceil(remaining / monthlyContribution);
  }

  function getRecommendedMonths(input) {
    var months = 3;

    if (input.employment === 'contract') months += 1;
    if (input.employment === 'self') months += 2;
    if (input.employment === 'variable') months += 2;

    if (input.incomeSources === 'dual') months -= 1;
    if (input.incomeSources === 'multiple') months -= 1;

    if (input.dependents === 'some') months += 1;
    if (input.dependents === 'many') months += 2;

    if (input.jobMarket === 'hot') months -= 1;
    if (input.jobMarket === 'tough') months += 2;

    // The risk adjustments above can only add up to 6 on top of the base 3,
    // so 9 is the true ceiling of this model. The clamp states it honestly.
    return Math.max(3, Math.min(9, months));
  }

  function calculate(input) {
    var expenses = input.expenses || {};
    var totalMonthlyExpenses = Object.keys(expenses).reduce(function (sum, key) {
      if (key.indexOf('Display') !== -1) return sum;
      return sum + (expenses[key] || 0);
    }, 0);

    var recommendedMonths = getRecommendedMonths(input);
    var targetEmergencyFund = totalMonthlyExpenses * recommendedMonths;
    var currentMonthsCovered = totalMonthlyExpenses === 0 ? 0 : (input.currentSavings / totalMonthlyExpenses);
    var progressPercent = targetEmergencyFund === 0 ? 0 : Math.round((input.currentSavings / targetEmergencyFund) * 100);

    var remaining = targetEmergencyFund - input.currentSavings;
    var timeToGoal;
    if (remaining <= 0) {
      timeToGoal = 'Goal reached!';
    } else if (input.monthlyContribution <= 0) {
      timeToGoal = 'Set a monthly contribution';
    } else {
      var months = Math.ceil(remaining / input.monthlyContribution);
      if (months === 1) {
        timeToGoal = '1 month to go';
      } else if (months < 12) {
        timeToGoal = months + ' months to go';
      } else {
        var years = Math.floor(months / 12);
        var remainingMonths = months % 12;
        if (remainingMonths === 0) {
          timeToGoal = years + ' year' + (years > 1 ? 's' : '') + ' to go';
        } else {
          timeToGoal = years + 'y ' + remainingMonths + 'm to go';
        }
      }
    }

    var milestones = [1, 3, 6, 12].map(function (months) {
      var amount = totalMonthlyExpenses * months;
      var monthsToReach = getMonthsToReach(amount, input.currentSavings, input.monthlyContribution);
      return {
        months: months,
        amount: amount,
        reached: input.currentSavings >= amount,
        monthsToReach: Number.isFinite(monthsToReach) ? monthsToReach : '∞'
      };
    });

    // Always show at least a 6-month window, even when current savings already
    // cover (or comfortably exceed) the target. Without this floor, a large
    // overshoot drives the "+6 month buffer" calculation negative, which made
    // the for-loop below run zero times and left the trajectory chart, the
    // monthly timeline table, and the CSV/PDF export completely empty even
    // though "Time to goal" correctly reported "Goal reached!".
    var maxMonths = input.monthlyContribution > 0
      ? Math.min(36, Math.max(6, Math.ceil((targetEmergencyFund - input.currentSavings) / input.monthlyContribution) + 6))
      : 24;

    var labels = [];
    var savings = [];
    var currentAmount = input.currentSavings;
    for (var i = 0; i <= maxMonths; i++) {
      labels.push(i);
      savings.push(currentAmount);
      currentAmount += input.monthlyContribution;
    }

    return {
      totalMonthlyExpenses: totalMonthlyExpenses,
      recommendedMonths: recommendedMonths,
      targetEmergencyFund: targetEmergencyFund,
      currentMonthsCovered: currentMonthsCovered,
      progressPercent: progressPercent,
      timeToGoal: timeToGoal,
      milestones: milestones,
      chart: {
        labels: labels,
        savings: savings,
        targetLine: labels.map(function () { return targetEmergencyFund; })
      }
    };
  }

  return {
    calculate: calculate,
    getRecommendedMonths: getRecommendedMonths
  };
});
